// How the user knows a draft scope (warnings, confirmations).

const PAGES = {
  "scheduling:rules": "Scheduling Rules",
  "scheduling:blocks": "Scheduling Blocks",
  "analitica:tracking": "Global Tracking",
  "datapanel:analitica": "Data Panel › Analitica"
};

// The scope as the user knows it. propertyTitle(id): the title of a property.
export function scopeLabel(scope, propertyTitle = () => undefined) {
  if (PAGES[scope]) return PAGES[scope];
  if (scope.startsWith("properties:")) {
    const id = scope.slice("properties:".length);
    return `the property "${propertyTitle(id) ?? id}"`;
  }
  return scope;
}

// "<label> <id> has unsaved changes in <scope>: save or discard them there
// first." for a row a page can't change or save (held by another scope).
export function heldMessage({ accessor, id, label }, scopeName) {
  return `${label ?? accessor} ${id} has unsaved changes in ${scopeName}: save or discard them there first.`;
}
